/**
 * QuickActionsPanel — vertical button stack for the most common
 * staff-side actions. Plain themed buttons; no metrics or animations.
 */

import { useNavigate } from 'react-router-dom';
import { Button, Card, Group, Stack, ThemeIcon, Title } from '@/components/ui';
import {
  IconBolt,
  IconPlus,
  IconCalendarTime,
  IconUserCircle,
  IconFolder,
  IconShieldCheck,
  IconBell,
} from '@tabler/icons-react';

interface Action {
  label: string;
  icon: React.ReactNode;
  to: string;
}

const ACTIONS: Action[] = [
  { label: 'Apply for Leave', icon: <IconPlus size={16} />, to: '/app/members/my-leaves/new' },
  { label: 'My Leaves', icon: <IconCalendarTime size={16} />, to: '/app/members/my-leaves' },
  { label: 'My Profile', icon: <IconUserCircle size={16} />, to: '/app/members/my-profile' },
  { label: 'My Files', icon: <IconFolder size={16} />, to: '/app/members/my-files' },
  { label: 'My Policies', icon: <IconShieldCheck size={16} />, to: '/app/members/my-policies' },
  { label: 'Announcements', icon: <IconBell size={16} />, to: '/app/members/announcements' },
];

export function QuickActionsPanel() {
  const navigate = useNavigate();
  return (
    <Card withBorder padding="lg" radius="md">
      <Group gap="xs" mb="sm">
        <ThemeIcon size="md" variant="light" color="indigo" radius="xl">
          <IconBolt size={16} />
        </ThemeIcon>
        <Title order={5}>Quick Actions</Title>
      </Group>
      <Stack gap="xs">
        {ACTIONS.map((a) => (
          <Button
            key={a.to}
            variant="default"
            justify="space-between"
            leftSection={a.icon}
            fullWidth
            onClick={() => navigate(a.to)}
          >
            {a.label}
          </Button>
        ))}
      </Stack>
    </Card>
  );
}
